import { allStates } from '../../../constants/states/all';
import { capitaliseFirstLetter } from '../../../helpers/capitaliseFirstLetter';
import { getStates } from '../../../helpers/getStates';
import { ProductBuilderMachineContext } from '../../../types';

export const idleGuardedTransitions = allStates.map(state => ({
  target: `#productBuilder.${state}`,
  cond: { type: `firstStateIs${capitaliseFirstLetter(state)}` },
}));

export const idleTransitionGuards = allStates.reduce((accumulator, state) => {
  return {
    ...accumulator,
    [`firstStateIs${capitaliseFirstLetter(state)}`]: (
      context: ProductBuilderMachineContext,
    ) => getStates(context)[0] === state,
  };
}, {});
